export class AuditBase {
  public issuerFullName = '';
  public userFullName = '';
  public date: Date = new Date();
  public auditAction = '';
}
